import classNames from 'classnames';
import { useEffect, useRef } from 'react';

type Props = {
    src: string;
    className?: string;
    loop?: boolean;
};

function Lottie({ src, className, loop = true }: Props) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = containerRef.current;

        if (!container) {
            return;
        }

        let animation: { destroy: () => void; resize: () => void } | null = null;
        let cancelled = false;

        const resizeObserver = new ResizeObserver(() => {
            animation?.resize();
        });

        resizeObserver.observe(container);

        import('lottie-web/build/player/lottie_light').then((lottie) => {
            if (cancelled) {
                return;
            }

            animation = lottie.default.loadAnimation({
                container,
                renderer: 'svg',
                loop,
                autoplay: true,
                path: new URL(src, window.location.origin).href,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid meet',
                },
            });
        });

        return () => {
            cancelled = true;
            resizeObserver.disconnect();
            animation?.destroy();
        };
    }, [src, loop]);

    return (
        <div
            ref={containerRef}
            className={classNames(className)}
            style={{ width: '100%', height: '100%' }}
            aria-hidden="true"
        />
    );
}

export default Lottie;
